module.exports = __webpack_public_path__ + "media/images/mail_template/in-49a6d928c786f1107e0380a7456067ca.png";